var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10V8C17.25 5.23858 15.0114 3 12.25 3C9.48858 3 7.25 5.23858 7.25 8V10M12.25 14.5V16.5M9.05 21H15.45C17.1302 21 17.9702 21 18.612 20.673C19.1765 20.3854 19.6354 19.9265 19.923 19.362C20.25 18.7202 20.25 17.8802 20.25 16.2V14.8C20.25 13.1198 20.25 12.2798 19.923 11.638C19.6354 11.0735 19.1765 10.6146 18.612 10.327C17.9702 10 17.1302 10 15.45 10H9.05C7.36984 10 6.52976 10 5.88803 10.327C5.32354 10.6146 4.8646 11.0735 4.57698 11.638C4.25 12.2798 4.25 13.1198 4.25 14.8V16.2C4.25 17.8802 4.25 18.7202 4.57698 19.362C4.8646 19.9265 5.32354 20.3854 5.88803 20.673C6.52976 21 7.36984 21 9.05 21Z",
    stroke: "#1369EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bad6bf8efa2bfcbfc224a8fd48af04fa.svg";
export { ForwardRef as ReactComponent };